import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Dimmer, Dropdown, Header } from 'semantic-ui-react';
import { parse } from '../../utils/queryString';
import { Spinner } from '../Spinner/Spinner';
import { AppState } from '../../types/app-state';
import { OrganisationParticipantSummaryReportState } from '../../types/organisationparticipantsummaryreport-state';
import {
	Destroy,
	Initialize,
	UpdateSelectedOrganisationId,
} from '../../actions/organisationparticipantsummaryreport.actions';
import './OrganisationParticipantSummaryReportPage.less';

export const OrganisationParticipantSummaryReportPage: React.FC = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const {
		loading,
		loadingReport,
		selectedOrganisationId: selectedOrgId,
		organisations,
		data,
	} = useSelector<AppState, Partial<OrganisationParticipantSummaryReportState>>(
		(state) => state.organisationparticipantsummaryreport
	);
	const orgOptions = (organisations ?? []).map((org) => ({
		key: 'org_' + org.id,
		value: org.id,
		text: org.name,
	}));

	const handleOrgSelect = (event: any, data: any) => {
		dispatch(UpdateSelectedOrganisationId(data.value));
	};

	useEffect(() => {
		const queryParams = parse(location.search);
		dispatch(Initialize(queryParams.orgId));
		return () => {
			dispatch(Destroy());
		};
	}, [dispatch, location]);

	return (
		<div className='orgparticipant-page'>
			<Dimmer inverted active={loading}>
				<Spinner />
			</Dimmer>
			<Header as='h3' className='header'>
				<div>Organisation Participant Summary Report</div>
				<Dropdown
					search
					selection
					placeholder='Select Organisation'
					value={selectedOrgId}
					onChange={handleOrgSelect}
					options={orgOptions}
				/>
			</Header>
			{loadingReport && <div className='loading-indicator'>Loading</div>}
			{!loadingReport && (
				<table>
					<thead>
						<tr>
							<th>Name of Coordinator</th>
							<th>Organisation Admin </th>
							<th>Participant First Name</th>
							<th>Participant Last Name</th>
							<th>NDIS Number</th>
							<th>Created date</th>
							<th>Updated date</th>
						</tr>
					</thead>
					{data && data.length > 0 && (
						<tbody>
							{data.map((item) => (
								<tr key={item.id}>
									<td>{item.coordinator}</td>
									<td>{item.is_admin}</td>
									<td>{item.participant_first}</td>
									<td>{item.participant_last}</td>
									<td>{item.ndis_number}</td>
									<td>{item.created}</td>
									<td>{item.updated}</td>
								</tr>
							))}
						</tbody>
					)}
					{data && data.length === 0 && (
						<tbody>
							<tr>
								<td colSpan={7} style={{ textAlign: 'center' }}>
									No Data
								</td>
							</tr>
						</tbody>
					)}
				</table>
			)}
		</div>
	);
};

export default OrganisationParticipantSummaryReportPage;
